import * as React from 'react';

import MultiSectionComboBox from 'bundles/employability-common/components/MultiSectionComboBox';

export type ComboBoxItem = {
  key: string;
  match: (term?: string) => number;
  onClick: (closePopover?: () => void) => void;
  label?: string;
  content: (term?: string, matches?: number) => React.ReactNode;
};

export type ComboBoxProps = {
  items: Array<ComboBoxItem>;
  onSearch?: (term: string, results: Array<ComboBoxItem>) => void; // for dynamic items
  activePlaceholder?: string;
  inactivePlaceholder?: React.ReactNode;
  footer?: (close: () => void) => React.ReactNode;
  header?: (close: () => void) => React.ReactNode;
  totalCount?: number; // override for the total records count
  fullWidth?: boolean;
  width?: string; // css value for width. discarded if fullWidth === true
  errorMessage?: string;
  'data-e2e'?: string;
};

const ComboBox: React.FC<ComboBoxProps> = (props) => {
  return <MultiSectionComboBox {...props} items={{ '': props.items }} />;
};

export default ComboBox;
